module.exports = __webpack_public_path__ + "static/media/chicago.05ece383.webp";